<template>
<div >
   
  
    
 

   
  <b-modal v-if="!modaldel" id="modal-1"  hide-footer title="Supprimer">
      <form @submit="deleteuser(user.id)">
    <p class="my-4">Voulez vous supprimer</p>
     <hr class="my-4" />
    <center>
       <b-btn type="button" style="background-color:#c2b59b;color:#fff" >non</b-btn>
      <b-btn type="submit"   style="background-color:#c2b59b;color:#fff" >oui</b-btn>
   
    </center> 
    </form>
  </b-modal>
   
    
   
   
</div>
</template>
<script>
import Usertable from './UserTable'
import { setToken, del } from "@/mixins/api";
export default {
     name: 'ModalDeleteUser',
      components: {
    Usertable
  },
  
    data() {
      
      return {

        modaldel:false,
        user:{
          id:'',
          name: '',
          email: '',
          
          phonenumber: '',

        },
        userToken:
        localStorage.getItem("userToken") ||
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImlhdCI6MTU3OTczNDkxMSwiZXhwIjoxNjExMjcwOTExfQ.96_I_ZUs7ALBMY4pDsnjbT-fvvagVMsVlpi48eAKWGk"
      
      }
    },
      methods:{
        getUser(data)
        {
          console.log(data)
          this.user=data;
        },
           deleteuser(id){
         
  del("user/"+id,this.user)
                 .then(resp => {
         
        this.output = resp.data.data;
        this.$emit(this.modaldel=false);
          
    }); this.modaldel = true;    
      },
      },
    
       mounted() {
    setToken(this.userToken);
    //this.loadData();
    
  },
}
</script>
                        